import { lazyLoad } from 'site-modules/shared/components/lazy-load/lazy-load';

export const BrandAssociationSurveyAsync = lazyLoad({
  loader: () => import(/* webpackChunkName: "brand-survey" */ './brand-association-survey'),
  componentName: 'BrandAssociationSurvey',
});
